<template>
  <div class="solution-detail">
    <div class="banner" v-if="isMobile" :style="{ backgroundImage: `url(${datalist.mbanner})` }">
      <h1>{{ datalist.name }}</h1>
      <p>{{ datalist.description }}</p>
      <div class="inner_btn">
        <button @click="goToContact(2)" class="inner-le">Eco-cooperation</button>
        <button @click="goToContact(3)" class="inner-ri">Contact us</button>
      </div>
    </div>
    <div class="banner" v-else :style="{ backgroundImage: `url(${datalist.banner})` }">
      <h1>{{ datalist.name }}</h1>
      <p>{{ datalist.description }}</p>
      <div class="inner_btn">
        <button @click="goToContact(2)" class="inner-le">Eco-cooperation</button>
        <button @click="goToContact(3)" class="inner-ri">Contact us</button>
      </div>
    </div>

    <div class="detail-content">
      <div class="content" v-html="datalist.context"></div>
    </div>

    <div v-if="(case_data||[]).length" class="success_outer">
      <div class="success">
        <h1>Success Cases</h1>
        <div class="succ-box" v-if="isMobile">
          <el-row :gutter="20">
            <el-col :span="24" v-for="item in case_data" :key="item.id" style="height: 18em;">
              <div class="grid-content">
                <div class="grid-top">
                  <img :src="item.thumbnail" alt="">
                </div>
                <div class="grid-bottom" @click="goto_case(item.id)">
                  <h3>{{ item.name }}</h3>
                  <p>{{ item.description }}</p>
                  <el-button>View More</el-button>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="succ-box" v-else>
          <el-row :gutter="20">
            <el-col :span="8" v-for="item in case_data" :key="item.id" style="height: 25em;">
              <div class="grid-content">
                <div class="grid-top">
                  <img :src="item.thumbnail" alt="">
                </div>
                <div class="grid-bottom">
                  <h3>{{ item.name }}</h3>
                  <p>{{ item.description }}</p>
                  <el-button @click="goto_case(item.id)">View More</el-button>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup name="SolutionDetailEN">
import { onMounted, ref, onUnmounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { getSolutionDetail } from '@/api/solution';
import { watch } from 'vue';

const route = useRoute();
const router = useRouter();
const id = ref(route.query.id);
const datalist = ref({});
const case_data = ref([]);
const isMobile = ref(false);

onMounted(() => {
  window.scrollTo(0, 0);
  checkMobile();
  window.addEventListener('resize', checkMobile);
  solutionrender();
});

onUnmounted(() => {
  window.removeEventListener('resize', checkMobile);
});

const checkMobile = () => {
  isMobile.value = window.innerWidth <= 1024;
};

watch(
  () => route.query.id,
  (newId, oldId) => {
    if (newId && newId !== oldId) {
      id.value = newId;
      window.scrollTo(0, 0);
      case_data.value = [];
      solutionrender();
    }
  },
  { immediate: true }
);

const emit = defineEmits(['scroll-to-contact']);
function goToContact(type) {
  emit('scroll-to-contact', type);
}

function goto_case(id) {
  router.push(`/en/casedetail?id=${id}`);
}

async function solutionrender() {
  const res = await getSolutionDetail(id.value);
  datalist.value = res.data;
  case_data.value = res.data.subObjects || [];
}

</script>

<style scoped>
.solution-detail {
  width: 100%;
}

.banner {
  overflow: hidden;
  width: 100%;
  height: 12em;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  color: white;
  background-color: #ddd;
  margin-bottom: 0;
  background-size: 100% 100%;
  background-position: center;
  text-align: left;
  background-repeat: no-repeat;
}

.banner h1 {
  width: 65%;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-top: 1em;
  margin-left: 18%;
  font-size: 22px;
  font-weight: 600;
}

.banner p {
  width: 65%;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-top: 0.5em;
  margin-left: 18%;
  line-height: 1.5em;
  max-height: 3em;
}

.inner_btn {
  margin-left: 18%;
}

.inner-le,
.inner-ri {
  width: 10em;
  height: 2.2em;
  border-radius: 1.5em;
  font-size: 1em;
  border: transparent;
  cursor: pointer;
  margin: 1em auto;
}

.inner-le {
  background-color: orange;
  color: white;
  margin-right: 1em;
}

.inner-ri {
  background-color: skyblue;
  color: white;
}

.detail-content {
  width: 60%;
  margin: 2em auto;
}

:deep(.content) {
  line-height: 1.8em;
  font-size: 15px;
}

:deep(.content img) {
  max-width: 100%;
  height: auto;
}

:deep(.content p) {
  margin: 0.5em 0;
}

:deep(.content h1),
:deep(.content h2),
:deep(.content h3),
:deep(.content h4) {
  margin: 1em 0 0.5em;
}

:deep(.content video) {
  width: 100%;
  max-height: 30em;
}

:deep(.content table) {
  max-width: 100%;
  border-collapse: collapse;
}

:deep(.content table td),
:deep(.content table th) {
  border: 1px solid #ddd;
  padding: 0.5em;
}

.success_outer {
  width: 100%;
  overflow: hidden;
  background-color: #F9FAFC;
}

.success {
  width: 60%;
  margin: 4em auto;
}

.success > h1 {
  margin-bottom: 1em;
}

.success .succ-box {
  margin-top: 4em;
}

.success .succ-box .el-row {
  display: flex;
  flex-wrap: wrap;
}

.success .succ-box .el-col {
  display: flex;
  flex-direction: column;
}

.success .succ-box .grid-content {
  width: 100%;
  height: 100%;
  background-color: #fff;
  display: flex;
  flex-direction: column;
}

.success .succ-box .grid-content .grid-top {
  width: 100%;
  height: 40%;
}

.success .succ-box .grid-content .grid-top img {
  width: 100%;
  height: 100%;
}

.success .succ-box .grid-content .grid-bottom {
  width: 90%;
  height: 60%;
  margin: 0 1em;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}

.success .succ-box .grid-content .grid-bottom > p {
  display: -webkit-box;
  height: 3em;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.success .succ-box .grid-content .grid-bottom h3,
.success .succ-box .grid-content .grid-bottom p {
  margin: 1em 0;
}

.success .succ-box .grid-content .grid-bottom h3 {
  height: 2em;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
}

.success .succ-box .grid-content .grid-bottom .el-button {
  width: 30%;
  margin: 1.5em 0;
  border: 1px solid #000;
  border-radius: 0;
  color: #000;
}

@media (max-width: 1024px) {
  .banner {
    height: 12em;
    margin-bottom: 1em;
    text-align: center;
  }

  .banner h1 {
    font-size: 1.2em;
    margin-top: 1em;
    margin-left: 3em;
    text-align: left;
    width: 80%;
  }

  .banner p {
    margin-top: 1em;
    margin-left: 3em;
    text-align: left;
    width: 80%;
  }

  .inner_btn {
    margin-left: 0;
  }

  .inner-le,
  .inner-ri {
    font-size: 0.8em;
    height: 2.5em;
  }

  .detail-content {
    width: 88%;
  }

  .success_outer {
    background-color: #005BAC;
  }

  .success {
    text-align: center;
    width: 90%;
    margin: 1em auto;
  }

  .success > h1 {
    font-size: 1.2em;
  }

  .success .succ-box {
    margin-top: 1em;
  }

  .success .succ-box .grid-bottom h3 {
    font-size: 1em;
  }

  .success .succ-box .grid-bottom > p {
    font-size: 0.8em;
  }

  .success .succ-box .grid-bottom .el-button {
    width: 20%;
    font-size: 0.8em !important;
  }
}
</style>
